import { Divider, type DividerProps } from "@chakra-ui/react";
import type { FunctionComponent } from "react";

export const DashedDivider: FunctionComponent<DividerProps> = (props) => (
  <Divider
    borderWidth="0"
    borderStyle="dashed"
    borderColor="grey.300"
    borderTopWidth="1px"
    orientation="horizontal"
    {...props}
  />
);
